import React from 'react'
import moment from 'moment'
import OperacionesCodigosDeCupo from '../components/OperacionesCodigosDeCupo'
import TableValueAction from '../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../../Camiones/containers/busquedaCpa/InfoCpa'

export function getColumnasCodigosDeCupo (rol = null) {
  const rolExterno = rol && rol.length > 0
  const columnas = [
    {
      name: 'fechaCupo',
      label: 'Fecha',
      options: {
      // El listado muestra solo una fecha a la vez,se saca filtro por fecha
      // si se agrega un calendario que pueda seleccionar varias fechas a la vez
      // habilitar este filtro
        filter: false,
        sort: true,
        filterList: [],
        filterType: 'multiselect',
        customBodyRender: f => {
          moment.locale('ar-AR')
          // En el calendario se ve la fecha. No se muestra año en listado.
          const fecha = moment(f).format('DD/MM')
          return <div>{fecha}</div>
        }
      }
    },
    {
      name: 'exportador',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        filterList: [],
        display: (rol ? rol[0] !== 'EXPORTADOR' && rol[1] !== 'EXPORTADOR' : false)
      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        filterList: []
      }
    },
    {
      name: 'cargador',
      label: 'Titular de cupo',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        filterList: [],
        display: (rol ? rol[0] !== 'CARGADOR' && rol[1] !== 'CARGADOR' : false)
      }
    },
    {
      name: 'corredor',
      label: 'Corredor',
      options: {
        filter: true,
        sort: true,
        filterList: [],
        filterType: 'multiselect',
        display: (rol ? rol[0] !== 'CORREDOR' && rol[1] !== 'CORREDOR' : false)
      }
    },
    {
      name: 'tipoCupo',
      label: 'Tipo',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      }
    },
    {
      name: 'codigoCupo',
      label: 'Codigo Cupo',
      options: {
        filter: false,
        sort: true,
        customBodyRender: codigo => {
          return <div style={{ fontWeight: 'bold' }}>{codigo}</div>
        }
      }
    },
    {
      name: 'stopq',
      label: 'Estado StopQ',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      }
    },
    {
      name: 'dataCTG',
      label: 'CTG',
      options: {
        filter: false,
        sort: true,
        customBodyRender: d => {
          const estadoConsumo = d['estadoCupoStopq']
          const cpa = estadoConsumo && estadoConsumo.replace(/[^0-9]+/g, '') // retorna solo el número de cpa.
          const estado = d['estado']
          const enTerminal = (estado === 'En Terminal') || (estado === 'Descargado') ||
                             (estado === 'Abandono') || (estado === 'Rechazado') ||
                             (estado === 'Rechazo administrativo')
          return (
            <>
              {cpa
                ? (enTerminal)
                  ? <TableValueAction
                    value={cpa}
                    title=' '
                    content={<InfoCpa cpa={cpa} />}
                  />
                  : <>{cpa}</>
                : null
              }
            </>
          )
        }
      }
    },
    {
      name: 'fechaDeNominacion',
      label: 'Fecha de nominación',
      options: {
        filter: false,
        sort: true,
        display: (rol && rol[0] === 'EXPORTADOR'),
        customBodyRender: (f) => {
          return (f ? moment(f).format('DD-MM-YYYY HH:mm') : ' ')
        }
      }
    },
    {
      name: 'estado',
      label: 'Estado',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        filterList: [],
        display: !rolExterno,
        viewColumns: !rolExterno,
        customBodyRender: (e) => {
          return (e === 'Sin consumir' ? <div style={{ textAlign: 'left' }} /> : <div style={{ textAlign: 'left' }}>{e}</div>)
        }
      }
    },
    {
      name: 'fechaDeAsignacionCupo',
      label: 'Asignación',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (f) => {
          return (f ? moment(f).format('DD-MM HH:mm') : ' ')
        }
      }
    },
    {
      name: 'entry',
      label: ' ',
      options: {
        print: false,
        filter: false,
        sort: false,
        customBodyRender: (entry) => {
          return <OperacionesCodigosDeCupo data={entry} />
        }
      }
    }
  ]
  return columnas
}

export const COLUMNS_CODIGO_DE_CUPOS_TO_PRINT = [
  {
    name: 'exportador',
    label: 'Exportador',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaCupo',
    label: 'Fecha de cupo',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'cargador',
    label: 'Titular de cupo',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'corredorVendedor',
    label: 'Corredor',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'tipoCupo',
    label: 'Tipo de cupo',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'codigoCupo',
    label: 'Codigo de cupo',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'stopq',
    label: 'Estado StopQ',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'estadoCupoStopq',
    label: 'StopQ',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'arribo',
    label: 'Arribo',
    width: 60,
    mantenerCase: true
  }
]

export const CODIGO_DE_CUPOS_EXTERNOS_TO_PRINT = [
  {
    name: 'exportador',
    label: 'Exportador',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'fechaCupo',
    label: 'Fecha de cupo',
    width: 70,
    mantenerCase: true
  },

  {
    name: 'cargador',
    label: 'Titular de cupo',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'corredorVendedor',
    label: 'Corredor',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'tipoCupo',
    label: 'Tipo de cupo',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'codigoCupo',
    label: 'Codigo de cupo',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'stopq',
    label: 'Estado StopQ',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'estadoCupoStopq',
    label: 'StopQ',
    width: 70,
    mantenerCase: true
  }
]

// Columnas para tabla de códigos de cupo

export const COLUMNS_TOTAL_CODIGO_DE_CUPOS = [
  {
    name: 'fechaDeEmisionDate',
    label: 'Fecha Cupo',
    options: {
      // El calendario ya filtra por fecha de cupo
      filter: false,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: f => {
        moment.locale('ar-AR')
        const fecha = moment(f).format('DD/MM')
        return <div>{fecha}</div>
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'nominado',
    label: 'Nominados',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'consumido',
    label: 'Consumidos',
    options: {
      filter: false,
      sort: true,
      customBodyRender: n => {
        return <div style={{ fontWeight: 'bold' }}>{n}</div>
      }
    }
  },
  {
    name: 'disponible',
    label: 'Disponibles',
    options: {
      filter: false,
      sort: true
    }
  }
]
